import * as yup from 'yup';

// Reusable function to check for leading or trailing spaces
export const noLeadingOrTrailingSpaces = fieldName =>
    yup.string().test({
        name: 'no-leading-or-trailing-spaces',
        message: `${fieldName} cannot have spaces at the beginning or end`,
        test: value => !/^\s|\s$/.test(value),
    });
